import React, { useEffect, useState } from 'react';
import ButtonCustomIcon from '../../../utils/custom-button-icon';
import ButtonCustomIcon2 from '../../../utils/custom-button-icon2';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { getPostalCodes } from '../../../services/postal_code_service';
import { PressData } from '../../../models/listpress';
import { ToastContainer, toast } from 'react-toastify';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import { SlArrowLeft } from 'react-icons/sl';
import { GoArrowLeft, GoArrowRight } from 'react-icons/go';
import { isValid, format } from 'date-fns';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';


interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}

const societyTypes = [
    "Association d'Avocats à Responsabilité Professionnelle Individuelle",
    "Entreprise unipersonnelle à responsabilité limitée",
    "Exploitation agricole à responsabilité limitée",
    "Groupement agricole d'exploitation en commun",
    "Groupement foncier agricole",
    "Société à responsabilité limitée",
    "Société à responsabilité limitée à capital variable",
    "Société anonyme",
    "Société Civile",
    "Société Civile de moyens",
    "Société civile d'exploitation agricole",
    "Société civile immobilière",
    "Société civile immobilière à capital variable",
    "Société civile immobilière de construction vente",
    "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
    "Société de Participations Financières de Profession Libérale Société par actions simplifiée Unipersonnelle",
    "Société d'exercice libéral à responsabilité limitée",
    "Société d'exercice libéral par action simplifiée",
    "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
    "Société en nom collectif",
    "Société Interprofessionnelle de Soins Ambulatoires",
    "Société par actions simplifiée",
    "Société par actions simplifiée à capital variable",
    "Société par actions simplifiée unipersonnelle",
    "Société par actions simplifiée unipersonnelle à capital variable"
]

const AnnonceRectificative: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {

    const {
        companyName,
        setCompanyName,
        currentAnnoucement
    } = useAppContext() as AppContextType

    const logCompanyName = (data: CompanyNameType) => {
    console.log("[LOG] companyName :", data);
    };

    logCompanyName(companyName);

    const [ errors, setErrors ] = useState<{ companyName?: string; texteAnnonce?: string }>({});
    const [ isSubmitted, setIsSubmitted ] = useState<boolean>(false);
    const [ legalForm, setLegalForm ] = useState<string>('');

    
    const validate = () => {
        const newErrors: { companyName?: string; texteAnnonce?: string } = {};
        if (!companyName.companyName) newErrors.companyName = "Le champ 'Dénomination' est obligatoire.";
        if (!txtAnnonce) newErrors.texteAnnonce = "Le champ 'Texte de l'annonce' est obligatoire.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

useEffect(() => {
  if (currentAnnoucement) {
    const tempTextAnnonce = `Rectificatif à l'annonce publiée dans ${currentAnnoucement.nomJal} du ${format(new Date(currentAnnoucement.createdAt), "dd/MM/yyyy")} concernant "${currentAnnoucement.denomination}". Il fallait lire :`;
    updateTxtAnnonce(tempTextAnnonce);

    setCompanyName(prev => {
      const updated = {
        ...prev,
        companyName: currentAnnoucement.denomination || prev.companyName,
        clientReference: (currentAnnoucement as any).clientReference || prev.clientReference || ''
      };
      return updated;
    });
  } else {
    console.warn("[AnnonceRectificative] Aucun currentAnnoucement trouvé !");
  }
}, []);



    
    const goToSupportPresse = () => {
        const isValid = validate()
        setIsSubmitted( true )
        if( isValid ){
            updateDenomination( companyName.companyName )
            updateActiveIndex(2)
        }
    }
    
    const goToAnnoucementType = () => {
        updateActiveIndex(0);
    }

    return (
        <div className='container mt-2'>
            <h6 className="border-bottom pb-2 bg-orange">RAISON SOCIALE</h6>
            <p>
                Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
            </p>

            <div className="mb-3 row">
                <label htmlFor="denomination" className="col-sm-3 col-form-label">Dénomination</label>
                <div className="col-sm-9">
                    <input
                        className={`form-control ${( errors.companyName && isSubmitted ) ? 'is-invalid' : ''}`}
                        type="text"
                        id="denomination"
                        value = { companyName.companyName }
                        onChange = { event => setCompanyName({ ...companyName, companyName: event.target.value })}
                    />
                    {
                        errors.companyName &&
                        isSubmitted &&
                        <small className="text-danger">{errors.companyName}</small>
                    }
                </div>
            </div>

            <div className="mb-3 row">
                <label htmlFor="clientRef" className="col-sm-3 col-form-label">Référence client</label>
                <div className="col-sm-9">
                    <input
                        className = 'form-control'
                        type="text"
                        id="clientRef"
                        value = { companyName.clientReference }
                        onChange = { event => setCompanyName({ ...companyName, clientReference: event.target.value })}
                    />
                </div>
            </div>

            <div className="mb-3 row">
                <label htmlFor="sociteChoice" className="col-sm-3 col-form-label">Société concernée</label>
                <div className="col-sm-9">
                    <select
                    className='form-select'
                    id="sociteChoice"
                    name="sociteChoice"
                    onChange = { event => setLegalForm( event.target.value ) }
                    value = { legalForm }
                    >
                        <option value=""></option>
                    {
                        societyTypes.map((option, index) => (
                        <option key={index} value={option}>
                            {option}
                        </option>
                        ))
                    }
                    </select>
                </div>
            </div>

            <h6 className="border-bottom pb-2">L'ANNONCE</h6>
            <div className="mb-3 row">
                <label htmlFor="texteAnnonce" className="col-sm-3 col-form-label">Texte de l'annonce</label>
                <div className="col-sm-9">
                    <textarea
                        className={`form-control ${( errors.texteAnnonce && isSubmitted ) ? 'is-invalid' : ''}`}
                        id="texteAnnonce"
                        rows = { 3 }
                        value = { txtAnnonce }
                        onChange = { event => updateTxtAnnonce( event.target.value ) }
                    >
                    </textarea>
                    {
                        errors.texteAnnonce &&
                        isSubmitted &&
                        <small className="text-danger">{errors.texteAnnonce}</small>
                    }
                </div>
            </div>

            
            <div className='button-container'>
                <div className="d-flex gap-2">
                    
                    <button
                        className="btn-add"
                        type="button"
                        onClick={goToAnnoucementType}
                    >
                        <GoArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                        Précédent
                    </button>
                    
                    <button
                        className="btn-add"
                        type="button"
                        onClick={goToSupportPresse}
                    >
                        Sélection du support
                        <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                    </button>
                </div>
            </div>

        </div>
    )
};

export default AnnonceRectificative;